export default {
    callHistory: state => state.callHistory
}
